import type { ReactNode } from 'react'
import type { PublishedLocale } from '@gjl/types'
import { LocaleContext } from './locale-context'

/** Wraps the app in its language tree. Rendered by `mountClient` and `createRenderBody`. */
export function LocaleProvider({ locale, children }: { locale: PublishedLocale | undefined; children: ReactNode }) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
}
